import userService from "../../../services/user.service";

async function getCountries() {
  try {
    const response = await userService.getCountries();
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return JSON.stringify(response.data.message) || "Failed to fetch countries.";
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching countries:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  getCountries,
  countryTools: [
    {
      type: "function",
      function: {
        name: "getCountries",
        description:
          "Fetch all countries from the database.",
        parameters: {
          type: "object",
          properties: {},
          required: [],
        },
      },
    },
  ],
};
